import { render, staticRenderFns } from "./InfoArea.vue?vue&type=template&id=b286e81a&scoped=true"
import script from "./InfoArea.vue?vue&type=script&lang=js"
export * from "./InfoArea.vue?vue&type=script&lang=js"
import style0 from "./InfoArea.vue?vue&type=style&index=0&id=b286e81a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b286e81a",
  null
  
)

export default component.exports